import { render, staticRenderFns } from "./DeleteProjectStatus.vue?vue&type=template&id=82d8e434"
import script from "./DeleteProjectStatus.vue?vue&type=script&lang=js"
export * from "./DeleteProjectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports